import { SimpleTable } from "adminlte-2-react";
import React, { useEffect, useState } from "react";
import { API } from "../../constant";
import { fetchWithAuth } from "./../../api/fetchWithAuth";

const columns = [
	{ title: "время", data: "date" },
	{ title: "отклонение, %", data: "deviation" },
];

function DeviationLog({ period, unitId }) {
	const [logData, setLogData] = useState([]);

	const fetchLog = async () => {
		try {
			const response = await fetchWithAuth(
				`${API}/deviation-log?unitId=${unitId}&period=${period}`,
			);
			const data = await response.json();
			if (typeof data !== "undefined" && data.length > 0) {
				setLogData(data);
			} else {
				setLogData([{ date: "команды отсутствуют" }]);
			}
		} catch (error) {
			console.error(error);
		}
	};

	useEffect(() => {
		fetchLog();
	}, []);

	return (
		<SimpleTable
			hover
			condensed
			border
			striped
			columns={columns}
			data={logData}
		/>
	);
}

export default DeviationLog;
